





























import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import { VForm } from "@/common/vuetify_types";
import * as validation from "@/tool/validation";
import { FavoriteCategory } from "@/api";

@Component
export default class FavoriteCategoryForm extends Vue {
  @Ref("form") form!: VForm;
  @Prop() action!: string;
  @Prop() category!: FavoriteCategory;

  formCategory = JSON.parse(JSON.stringify(this.category));
  loading = false;
  requiredTextInput = [validation.requiredString, validation.noSpace];

  close() {
    this.form.reset();
    this.$emit("close");
  }

  async save() {
    const isValid = this.form.validate();
    if (isValid) {
      try {
        this.loading = true;
        await this.$store.dispatch(
          `favoriteCategory/${this.action}`,
          this.formCategory,
        );
        this.loading = false;
        this.close();
      } catch (e) {
        console.log(e);
      }
    }
  }
}
